// Internal Intl wrapper — not part of the public surface.
import { getDateTimeFormat } from './formatter-cache';

/**
 * Format a Date with a (cached) `Intl.DateTimeFormat`, retrying without
 * `timeZone` if the zone identifier is invalid (RangeError). A bad zone falls
 * back to the runtime's default zone rather than throwing mid-render — display
 * robustness. Programmatic zone values are validated on write (PR2), so this is
 * a backstop.
 */
export function safeFormat(
    d: Date,
    opts: Intl.DateTimeFormatOptions,
    locale = 'en-US',
): string {
    try {
        return getDateTimeFormat(locale, opts).format(d);
    } catch {
        const { timeZone: _omit, ...rest } = opts;
        return getDateTimeFormat(locale, rest).format(d);
    }
}
